import React, { useState, useEffect } from "react";
import axios from "axios";
import { videosGet } from "../constants";
import ReactPlayer from "react-player/youtube";

import Error from "./Error";
import Loader from "./Loader";
import "../assets/styles/components/Latest.scss";
import nextButton from "../assets/static/images/next.png";
import previousButton from "../assets/static/images/previous.png";

const Latest = () => {
  const [element, setElement] = useState(0);
  const [key, setKey] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const movieId = JSON.parse(localStorage.getItem("movies"));

  const handleNextButton = () => {
    console.log("hizo clic");
    console.log(error);
    onEnded();
  };

  const handlePreviousButton = () => {
    console.log("hizo clic");
    console.log(error);
    onStarted();
  };
  async function nextMovie() {
    try {
      const response = await axios.get(`${videosGet(movieId[element].id)}`);
      const result = response.data.results;
      setKey(result[0].key);
      console.log(element);
      if (!result.length) {
        onEnded();
      }
      setLoading(false);
      setError(false);
    } catch (error) {
      setLoading(false);
      setError(error);
      setTimeout(() => {
        onEnded();
        console.log("UPSS!");
      }, 3000);
    }
  }

  const onEnded = () => {
    if (element < movieId.length) {
      setElement(element + 1);
    } else {
      setElement(0);
    }
  };
  const onStarted = () => {
    if (element > 0) {
      setElement(element - 1);
    } else {
      setElement(movieId.length - 1);
    }
  };

  useEffect(() => {
    nextMovie();
  }, [element]);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : error ? (
        <Error />
      ) : (
        <>
          <div className="latest-container">
            <ReactPlayer
              width="100%"
              height="100%"
              className="react-player"
              config={{
                youtube: {
                  playerVars: { showinfo: 1 },
                  origin: window.location.origin,
                },
              }}
              controls={true}
              loop={false}
              playing={true}
              volume={null}
              muted={true}
              onEnded={onEnded}
              url={`https://youtube.com/embed/${key}`}
            />
            <img
              className="buttonNext"
              src={nextButton}
              alt="next"
              onClick={handleNextButton}
            />
            <img
              className="buttonPrevious"
              src={previousButton}
              alt="previous"
              onClick={handlePreviousButton}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Latest;
